import { apiClient } from './api'
export interface OrganizationProfile {
  id: string; name: string; canRename: boolean
  history: { id: string; action_timestamp: string; oldName: string; newName: string; actorFirstName: string | null; actorLastName: string | null }[]
}
export const organizationService = {
  get: async (): Promise<OrganizationProfile> => (await apiClient.get('/api/me/organization')).data.data,
  rename: async (name: string, expectedName: string): Promise<OrganizationProfile> => (await apiClient.patch('/api/me/organization', { name, expectedName })).data.data,
}
